import { Chip, Grid, IconButton, Popover, Table, TableBody, TableCell, TableRow } from '@mui/material';
import { CustomerLocationOrder } from '../../store/config/types';
import { useRef, useState } from 'react';
import PackageGroupLink from '../PackageGroupLink/PackageGroupLink';
import { convertConstantLiteralToNormal } from '../../utils/string.helpers';
import { Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';

interface CustomerLocationOrderStatusProps {
  customerLocationOrder: CustomerLocationOrder;
}

export default function CustomerLocationOrderStatus({ customerLocationOrder }: CustomerLocationOrderStatusProps) {
  const anchorEl = useRef<HTMLDivElement | null>(null);
  const [open, setOpen] = useState(false);
  function handleClick(event: any) {
    event.preventDefault();
    event.stopPropagation();
    setOpen(true);
  }
  function handleClose() {
    setOpen(false);
  }
  if (customerLocationOrder.status == 'Mixed statuses') {
    return (
      <>
        <Chip label={customerLocationOrder.status} ref={anchorEl} clickable onClick={handleClick} />
        <Popover
          open={open}
          onClose={handleClose}
          anchorEl={anchorEl.current}
          onClick={(e) => {
            e.stopPropagation();
          }}
          //   anchorReference={{ left: 'center', horizontal: 'left' }}
        >
          <Grid container>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell colSpan={2}>
                    <Grid container>
                      <Grid item flexGrow={1}>
                        <Typography variant="subtitle1">Mixed statuses</Typography>
                      </Grid>
                      <Grid item>
                        <IconButton size="small" onClick={handleClose}>
                          <Close />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>

                {customerLocationOrder.packageGroups.map((packageGroup) => (
                  <TableRow key={packageGroup.packageGroupId}>
                    <TableCell>
                      <PackageGroupLink packageGroup={packageGroup} />
                    </TableCell>
                    {/* <TableCell>
                      {formatTimeWindow(packageGroup.timeWindowFrom ?? null, packageGroup.timeWindowTo ?? null, true)}
                    </TableCell> */}
                    <TableCell>
                      <Chip label={convertConstantLiteralToNormal(packageGroup.status)} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        </Popover>
      </>
    );
  }
  return <Chip label={customerLocationOrder.status} />;
}
